export default function TableUnderMapNoType() {
    return (
        <div className="table-under-map-no-object-type">
            Нет доступных объектов
        </div>
    )
}
